import axios from '@axios'

export default function filtroCustomApi(modulo) {
  return {
    verificarNome: (nome, id) => axios.get(`filtro-customizado/verificar-nome/${id}?nome=${nome}&modulo=${modulo}`),
    getFiltroCustomResumido: () => axios.get(`filtro-customizado/resumido?modulo=${modulo}`),
    getFiltroCustomById: id => axios.get(`filtro-customizado/${id}?modulo=${modulo}`),
    salvarFiltroCustom: filtro => axios.post(`filtro-customizado?modulo=${modulo}`, filtro),
    deleteFiltroCustom: filtroId => axios.delete(`filtro-customizado?filtroId=${filtroId}&modulo=${modulo}`),
    getUsuariosFiltro: () => axios.get(`filtro-customizado/usuarios-filtro?modulo=${modulo}`),
    getTotalEmpresas: () => axios.get(`filtro-customizado/empresas?modulo=${modulo}`),
    getTotalEmpresasFiltrado: body => axios.post(`filtro-customizado/empresas?modulo=${modulo}`, body),
  }
}
